import { FC, useState } from 'react';
import { Post } from '@libs/models';
import { usePost } from '@carcareers/hooks';
import { Checkbox } from '@mui/material';

interface RenewPostInputProps {
  post: Post;
  onSuccess?: () => Promise<void>;
}

export const RenewPostInput: FC<RenewPostInputProps> = ({ post, onSuccess }) => {
  const { renewPost } = usePost();
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    
    if (isLoading) return;
    
    setIsLoading(true);
    const newValue = !post.renew;
    const updatedPost = { ...post, renew: newValue };
    
    try {
      await renewPost(updatedPost);
      if (onSuccess) {
        await onSuccess();
      }
    } catch (error) {
      console.error('Failed to update renewal status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Checkbox
      checked={post.renew || false}
      onChange={handleChange}
      color="primary"
      disabled={isLoading}
    />
  );
};

export default RenewPostInput;
